// @ts-nocheck

import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useIntl } from 'react-intl';
import { ButtonUI, CustomThemeProvider, ModalUI, usePortal } from 'sonata-react-components';

import { ReportingAdvancedFilterModalStyled } from '@/modules/reporting/ReportingAdvancedFilterModal/reportingAdvancedFilterModal.styled';
import { ReportingSectionAdvancedFilter } from '../ReportingSectionAdvancedFilter';

function ReportingAdvancedFilterModal(props) {
  const { enabled = false, initialSettings, isModalOpened = false, onClose, section = 'general' } = props;
  const { formatMessage } = useIntl();
  const modalRef = useRef(null);
  const advanceFilterRef = useRef(null);
  const hasMount = useRef(false);

  const [{ isSaveButtonEnabled }, setState] = useState({
    isSaveButtonEnabled: true
  });

  useEffect(() => {
    if (isModalOpened) {
      if (modalRef && modalRef.current && modalRef.current.openModal) {
        modalRef.current.openModal();
      }
    } else if (hasMount.current && modalRef && modalRef.current && modalRef.current.closeModal) {
      modalRef.current.closeModal();
    }
    if (!hasMount.current) {
      hasMount.current = true;
    }
  }, [isModalOpened]);

  const handleButtonSaveChangesClick = () => {
    if (advanceFilterRef && advanceFilterRef.current && advanceFilterRef.current.applyChanges) {
      advanceFilterRef.current.applyChanges();
    }
    if (modalRef && modalRef.current && modalRef.current.closeModal) {
      modalRef.current.closeModal();
    }
  };

  const handleButtonResetFilterClick = () => {
    if (advanceFilterRef && advanceFilterRef.current && advanceFilterRef.current.reset) {
      advanceFilterRef.current.reset();
    }
  };

  const handleSaveButtonDisable = saveButtonStatus => {
    setState(prevState => ({
      ...prevState,
      isSaveButtonEnabled: saveButtonStatus
    }));
  };

  const targetBody = usePortal('modalAdvancedFilter');
  return ReactDOM.createPortal(
    <CustomThemeProvider themeContrast="light">
      <ReportingAdvancedFilterModalStyled className="advancedFilterModal">
        <ModalUI
          className="advancedFilterModal__modal"
          closeModalCallback={onClose}
          leftButton={
            <ButtonUI
              className="advancedFilterModal__button"
              icon="fal fa-trash"
              iconPosition="left"
              onClick={handleButtonResetFilterClick}
              text={formatMessage({
                defaultMessage: 'Reset filter',
                id: 'reporting.advancedFilters.modal.resetFilter'
              })}
              type="secondary"
            />
          }
          ref={modalRef}
          rightButton={
            <ButtonUI
              className="advancedFilterModal__button"
              disabled={!isSaveButtonEnabled}
              onClick={handleButtonSaveChangesClick}
              text={formatMessage({
                defaultMessage: 'Save changes',
                id: 'reporting.advancedFilters.modal.saveChanges'
              })}
            />
          }
          title={formatMessage({
            defaultMessage: 'Reporting filter view',
            id: 'reporting.advancedFilters.modal.title'
          })}
          width="805px"
        >
          {isModalOpened && (
            <ReportingSectionAdvancedFilter
              enabled={enabled}
              general
              initialSettings={initialSettings}
              isModal
              onSaveButtonDisable={handleSaveButtonDisable}
              ref={advanceFilterRef}
              section={section}
            />
          )}
        </ModalUI>
      </ReportingAdvancedFilterModalStyled>
    </CustomThemeProvider>,
    targetBody
  );
}

ReportingAdvancedFilterModal.propTypes = {
  enabled: PropTypes.bool, // delete when Reporting is pure React
  initialSettings: PropTypes.shape({
    chartTimeStep: PropTypes.oneOf(['hour', 'day', 'week', 'month', 'year']).isRequired,
    currency: PropTypes.string,
    timeFrame: PropTypes.shape({
      beginDate: PropTypes.string,
      endDate: PropTypes.string
    }),
    timeStep: PropTypes.oneOf(['hour', 'day', 'week', 'month', 'year']).isRequired,
    timeZone: PropTypes.string
  }),
  isModalOpened: PropTypes.bool,
  onClose: PropTypes.func,
  section: PropTypes.oneOf(['campaignsProgress', 'general', 'insights', 'map', 'overview', 'table'])
};

export default React.memo(ReportingAdvancedFilterModal);
